module.exports = __webpack_public_path__ + "static/media/ProbabilityTree.6281d45b.ai";